import type React from 'react';

interface Props {
  children: React.ReactElement;
  condition: boolean;
  wrapper: (children: JSX.Element) => JSX.Element;
}

export const ConditionalWrap: React.FC<Props> = ({ condition, wrapper, children }) =>
  condition ? wrapper(children) : children;
